import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ReadOnlyChatProvider } from "@/contexts/ReadOnlyChatContext";
import { ChainOfThoughtProvider } from "@/contexts/ChainOfThoughtProvider";
import { ScrollEngineProvider } from "@/contexts/ScrollEngineProvider";
import { TooltipProvider } from "@/components/ui/tooltip";

function PublicLayoutRoute() {
  return (
    <TooltipProvider>
      <ChainOfThoughtProvider>
        <ScrollEngineProvider>
          <ReadOnlyChatProvider>
            <Outlet />
          </ReadOnlyChatProvider>
        </ScrollEngineProvider>
      </ChainOfThoughtProvider>
    </TooltipProvider>
  );
}

export const Route = createFileRoute("/_public")({
  component: PublicLayoutRoute,
});
